import { withValidations } from 'common/validations/withValidation';
import SearchInput from 'components/SearchInput';

export const SearchInputWithValidation = withValidations(SearchInput);
